import { render, staticRenderFns } from "./SimpleHeaderCroppedImage.vue?vue&type=template&id=ef759de6&name=simple-header-cropped-image&"
import script from "./SimpleHeaderCroppedImage.vue?vue&type=script&lang=js&"
export * from "./SimpleHeaderCroppedImage.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeaderCroppedImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports